module.exports = __webpack_public_path__ + "img/service1.bb53fd0d.png";